import React from "react";
import { useTranslation } from "react-i18next";
import ExperienceCollectionArcFrame from "./ExperienceCollectionArcFrame";
import ExperienceCollectionCards from "./ExperienceCollectionCards";
import ExperienceCollectionQuote from "./ExperienceCollectionQuote";

const ExperienceCollection = () => {
  const { t } = useTranslation();
  return (
    <section className="section bottom-5">
      <div className="container">
        <div className="arc-header-div no-max">
          <h2 className="heading-9vw m-14">{t("home.experience.title")}</h2>
        </div>
        <ExperienceCollectionArcFrame />
        <div className="home-collection">
          <div className="home-col-container">
            <ExperienceCollectionCards />
            <ExperienceCollectionQuote />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceCollection;
